var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolasBrancas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1208.954,
    height: 1342.903,
    viewBox: "0 0 1208.954 1342.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.02;}.b,.c{fill:none;stroke:#fff;stroke-width:6px;}.b{stroke-miterlimit:10;}.c{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.959)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.959 999.868)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(865.92 252.668)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 746.985)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(865.92 746.985)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 252.668)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 168.517,
    cy: 168.517,
    r: 168.517
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 134.814,
    cy: 134.814,
    r: 134.814,
    transform: "translate(33.703 33.703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolasBrancas);
export default __webpack_public_path__ + "static/media/bolasBrancas.dfad5715332b72d5ab4ce35b157ea05f.svg";
export { ForwardRef as ReactComponent };